import urljoin from 'url-join';
import fontManagerService from '@/utils/fontManagerService';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('SideBarCtrl', sideBarCtrl);

    function sideBarCtrl($rootScope, $scope, $mdDialog, $location, $timeout, $window, UsersAPIService) {
        $scope.currentRoute = '/home';
        $scope.bullMqJobsUrl = urljoin(process.env.VUE_APP_SHOPIFY_APP_URL, '/admin/bullmq');

        $scope.$watch('user', function () {
            if ($scope.user) {
                // Generate initials from current username and impersonated user
                if ($scope.user.UserImpersonatedFrom) {
                    const name = $scope.user.UserImpersonatedFrom.Name || $scope.user.UserImpersonatedFrom.Username;
                    $scope.userInitials = name.toUpperCase().slice(0, 2);
                    $scope.impersonatedUserInitials = $scope.user.Username.toUpperCase().slice(0, 2);
                } else {
                    $scope.userInitials = $scope.user.Username.toUpperCase().slice(0, 2);
                }
            }
        });

        if ($rootScope.user) {
            // Generate initials from current username and impersonated user
            if ($scope.user.UserImpersonatedFrom) {
                const name = $rootScope.user.UserImpersonatedFrom.Name || $rootScope.user.UserImpersonatedFrom.Username;
                $scope.userInitials = name.toUpperCase().slice(0, 2);
                $scope.impersonatedUserInitials = $rootScope.user.Username.toUpperCase().slice(0, 2);
            } else {
                $scope.userInitials = $rootScope.user.Username.toUpperCase().slice(0, 2);
            }
        }

        // Set initial route
        $scope.currentRoute = $location.path();
        $scope.queryParams = $location.search();
        $scope.inMyDesign = 'forMyDesigns' in $scope.queryParams ? true : false;
        $scope.isMyProductBases = 'forMyProductBases' in $scope.queryParams ? true : false;

        // Impersonation variables
        $scope.usernames = null;
        $scope.isAdminUser = false;
        $scope.isParentUser = false;
        $scope.isChildUser = false;
        $scope.impersonateEnabled = false;

        // Listen for route changes
        $rootScope.$on('$routeChangeSuccess', function routeChangeHandler(event, current, previous) {
            if (current && current.$$route && current.$$route.originalPath) {
                $scope.currentRoute = $location.path();
                $scope.inMyDesign = false;
                $scope.isMyProductBases = false;
            }
        });

        $scope.goToHangfire = function () {
            window.location = '/hangfire';
        };

        $scope.openHelpCenter = function () {
            window.open('https://help.customily.com/hc/en-us', '_blank');
        };

        $scope.goToAccount = function () {
            $location.path('/account');
        };

        $scope.goToAdmin = function () {
            $location.path('/admin');
        };

        $scope.handleLibrariesRouting = function () {
            const path = localStorage.getItem('current-libraries-url') == 'legacy' ? 'libraries-legacy' : 'libraries';
            $location.path(`/${path}`);
        };

        $scope.truncateForDisplay = function (value, maxLength = 17) {
            //updating the user can cause the value to be null for a moment
            if (!value?.length) return '';
            return value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
        };

        $scope.hasParentUsername = function (item) {
            return item && item.ParentUsername && item.ParentUsername.length > 0;
        };

        $scope.$on('route:success', async (_, user) => {
            if (!user) {
                return;
            }

            $scope.isAdminUser =
                (user?.AccessRoles?.Serialized?.split(',').includes('admin') || user?.ImpersonatedFromAdminUser) &&
                !user?.ImpersonatedFromChildUser;
            $scope.isParentUser =
                user?.AccessRoles?.Serialized?.split(',').includes('parent') || user?.ImpersonatedFromParentUser || false;
            $scope.isChildUser =
                user?.AccessRoles?.Serialized?.split(',').includes('impersonate-parent') || user?.ImpersonatedFromChildUser || false;

            if ($scope.isAdminUser || $scope.isParentUser || $scope.isChildUser) {
                $scope.usernames = await UsersAPIService.getAllUsernames();

                // If the user has only one access, impersonate automatically
                if ($scope.usernames.length == 1 && !$scope.user?.ImpersonatedFromChildUser) {
                    const usernameToImpersonate = $scope.usernames[0].Username;
                    if (usernameToImpersonate != $scope.user?.Username) {
                        await $scope.changeUser(usernameToImpersonate);
                        return;
                    }
                }

                $scope.selectedUser = user?.Username;
                $scope.impersonateUser = '';
                $scope.impersonateEnabled = true;
                $timeout(() => $scope.$apply());
            }
        });

        $scope.changeUser = async function (username) {
            if (username) {
                $scope.isLoading = true;
                await UsersAPIService.impersonate(username);

                // Clear fonts so fonts from the new user are loaded
                fontManagerService.clearFontsCache();

                $window.location.reload();
                $scope.isLoading = true;
            }
        };

        $scope.openDialog = function ($event) {
            $mdDialog.show({
                controller: function ($scope, usernames, selectedUser, user, isAdminUser, impersonateUser) {
                    $scope.usernames = usernames;
                    $scope.userSearchText = '';
                    $scope.selectedUser = selectedUser;
                    $scope.user = user;
                    $scope.isAdminUser = isAdminUser;
                    $scope.impersonateUser = impersonateUser;
                    $scope.selectedParentUsername = null;
                    $scope.isLoading = false;
                    $scope.mdClose =
                        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=';

                    $scope.hasParentUsername = function (item) {
                        return item && item.ParentUsername && item.ParentUsername.length > 0;
                    };

                    $scope.usernameQuerySearch = function (query) {
                        const filteredUsernames = $scope.usernames.filter(function (username) {
                            return (username.Username || '').toLowerCase().includes((query || '').toLowerCase());
                        });
                        const sortedUsernames = filteredUsernames.sort((a, b) => {
                            return a.Username?.localeCompare(b.Username, undefined, { sensitivity: 'base' });
                        });
                        return sortedUsernames;
                    };
                    $scope.changeUser = async function () {
                        if ($scope.impersonateUser) {
                            $scope.isLoading = true;
                            await UsersAPIService.impersonate($scope.impersonateUser);

                            // Clear fonts so fonts from the new user are loaded
                            fontManagerService.clearFontsCache();

                            $window.location.reload();
                            $scope.isLoading = true;
                        }
                    };
                    $scope.setImpersonateUser = async function (item) {
                        if (item) {
                            // If it's a team member (has valid ParentUsername), impersonate the parent instead
                            if ($scope.hasParentUsername(item)) {
                                $scope.impersonateUser = item.ParentUsername;
                                $scope.selectedParentUsername = item.ParentUsername;
                            } else {
                                $scope.impersonateUser = item.Username;
                                $scope.selectedParentUsername = null;
                            }
                        }
                    };
                    $scope.closeDialog = function () {
                        $mdDialog.hide();
                    };
                },
                locals: {
                    usernames: $scope.usernames,
                    selectedUser: $scope.selectedUser,
                    user: $scope.user,
                    isAdminUser: $scope.isAdminUser,
                    impersonateUser: $scope.impersonateUser
                },
                template: require('../../../views/impersonateUserDialog.html'),
                parent: angular.element(document.body),
                targetEvent: $event,
                clickOutsideToClose: true
            });
        };
    }
})();
